import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { StudentProgress } from './types';

interface AchievementsTabProps {
  studentProgress: StudentProgress | undefined;
}

export const AchievementsTab: FC<AchievementsTabProps> = ({ studentProgress }) => {
  return (
    <Card className="bg-white shadow-sm border-[#E6EDF9]">
      <CardHeader>
        <CardTitle className="text-[#2B3674]">Logros</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {studentProgress?.achievements === 0 ? (
            <p className="text-[#707EAE] text-center py-4">
              Aún no hay logros registrados. ¡Anima a tu estudiante a seguir adelante!
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="p-4 border border-[#E6EDF9] rounded-lg bg-[#F4F7FE]">
                <p className="text-[#707EAE] text-center">
                  Próximamente podrás ver los logros de tu estudiante aquí.
                </p>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
